import React, { useState } from "react";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import { RNHEstablecimientoIns } from "services/services-mia/programa-salud/estructuras/RNHEstablecimientoIns";

import EstablecimientoFormulario, {
    valoresVacios,
} from "pages/programa-salud/estructuras/establecimientos/EstablecimientoFormulario";

import CamposHospital, {
    ANCHOS_HOSPITAL,
    reglasHospital,
    useCatalogosHospital,
    valoresHospitalVacios,
} from "./CamposHospital";

// Tipo de componente que administra esta página. El back lo llama "Dirección";
// acá seguimos hablando de hospitales. Códigos: H dirección · D departamento ·
// I división · U unidad · C caps · R uresa · P puesto · O posta.
const TIPO = "H";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    // El formulario no espera a los catalogos: los selects se muestran deshabilitados con
    // "Cargando..." y se llenan cuando llegan, igual que el de localidad.
    const { niveles, zonas } = useCatalogosHospital();

    const handleCreateHospital = async (values) => {
        setInRequest(true);

        // lat y lng ya vienen redondeados del mapa: los pone useUbicacion y el formulario los
        // mergea al enviar. zonaId no viaja: el servicio deduce la zona del area.
        const response = await RNHEstablecimientoIns(credentials, {
            ...values,
            type: TIPO,
        });

        if (response.ok) {
            setSnackBarInfo({
                message: "Hospital creado correctamente",
                severity: "success",
                open: true,
            });
            updateList();
            closeModal();
        }

        setInRequest(false);
    };

    return (
        <EstablecimientoFormulario
            initialValues={{ ...valoresVacios(), ...valoresHospitalVacios() }}
            onSubmit={handleCreateHospital}
            botonTexto="Crear"
            inRequest={inRequest}
            closeModal={closeModal}
            esAlta
            camposExtra={<CamposHospital niveles={niveles} zonas={zonas} />}
            reglasExtra={reglasHospital}
            // Mitades y no 40/60: con diez campos la columna de carga ya le da al
            // mapa el alto que necesita, y angostarla obligaria a partir en dos filas
            // pares que hoy entran juntas.
            mapaAncho={false}
            columnas={ANCHOS_HOSPITAL}
        />
    );
}
